var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3a0e206a8d7b4c13f8b3f72fdb24280959bd6bdd"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["straumur-web@kvika"]={id:"3a0e206a8d7b4c13f8b3f72fdb24280959bd6bdd"};
      